import React from "react";
import { v4 } from "uuid";

import TextFieldType from "../../FieldView/TextFieldType";
import TextAreaType from "../../FieldView/TextAreaType";
import RadioType from "../../FieldView/RadioType";
import CheckboxType from "../../FieldView/CheckboxType";
import DropdownType from "../../FieldView/DropdownType";
import DateType from "../../FieldView/DateType";
import NumberType from "../../FieldView/NumberType";
import DateDescriptionType from "../../FieldView/DateDescriptionType";
import CurrencyType from "../../FieldView/CurrencyType";
import TabField from "./TabField/TabField";

import "./TabSection.scss";
import CustomField from "../../FieldView/CustomField";
import SearchDropdownType from "../../FieldView/SearchDropdownType";

const CategoryA = ["TextField", "TextArea", "Number"];
const CategoryB = ["Dropdown", "Checkbox", "Radio"];

const TabSection = ({ documentViewMode, section, index, isFieldAcive, setIsFieldActive, ...props }) => {
  const [sectionFields, setSectionFields] = React.useState([]);

  React.useEffect(() => {
    setSectionFields([...section.sectionFields]);
  }, [section.sectionFields]);

  const handleAddField = () => {
    if (isFieldAcive) {
      return;
    }
    setIsFieldActive(true);

    const tempSectionFields = [...sectionFields];

    tempSectionFields.push({
      fieldId: v4(),
      inputType: "TextField",
      mode: "Create",
      fieldLabel: "",
      fieldValue: "",
      fieldRequired: false,
      fieldPlaceHolder: "",
    });

    setSectionFields(tempSectionFields);
  };

  const handleEditField = (fieldId) => {
    if (isFieldAcive) {
      return;
    }
    setIsFieldActive(true);

    const tempSectionFields = [...sectionFields];

    const fieldIndex = tempSectionFields.findIndex((sectionField) => sectionField.fieldId === fieldId);
    tempSectionFields[fieldIndex] = {
      ...tempSectionFields[fieldIndex],
      mode: "Edit",
    };

    setSectionFields(tempSectionFields);
  };

  const updatedField = (event, id, updateType) => {
    const tempSectionFields = [...sectionFields];
    tempSectionFields.map((field) => {
      let updatedField = field;
      if (updatedField.fieldId === id) {
        if (updateType === "Label") {
          updatedField.fieldLabel = event.target.value;
        } else if (updateType === "PlaceHolder") {
          updatedField.fieldPlaceHolder = event.target.value;
        } else if (updateType === "Description") {
          updatedField.fieldDescription = event.target.value;
        } else if (updateType === "Required") {
          updatedField.fieldRequired = !field.fieldRequired;
          if (!field.fieldRequired) {
            updatedField.setReminder = false;
          }
        } else if (updateType === "Reminder") {
          updatedField.setReminder = !field.setReminder;
          if (field.setReminder) {
            updatedField.fieldRequired = true;
          }
        } else {
          updatedField = field;
        }
      }
      return updatedField;
    });
    setSectionFields(tempSectionFields);
  };

  const cancelFieldHandler = (field) => {
    let tempSectionFields = [...sectionFields];
    if (field.mode === "Edit") {
      tempSectionFields = tempSectionFields.map((sectionField) => {
        if (sectionField.fieldId === field.fieldId) {
          return { ...sectionField, mode: "Created" };
        } else {
          return sectionField;
        }
      });
    } else {
      tempSectionFields = tempSectionFields.filter((sectionField) => sectionField.fieldId !== field.fieldId);
    }
    setIsFieldActive(false);
    setSectionFields(tempSectionFields);
  };

  const addOptionHandler = (id) => {
    let tempSectionFields = [...sectionFields];

    tempSectionFields = tempSectionFields.map((field) => {
      let updatedField = field;
      if (updatedField.fieldId === id) {
        updatedField.options = [...updatedField.options, { optionId: v4(), optionValue: "" }];
      }
      return updatedField;
    });

    setSectionFields(tempSectionFields);
  };

  const updateOptionValue = (event, id) => {
    let tempSectionFields = [...sectionFields];

    tempSectionFields = tempSectionFields.map((field) => {
      let updatedField = field;

      if (updatedField.options) {
        updatedField.options = updatedField.options.map((option) => {
          let result = option;
          if (result.optionId === id) {
            result.optionValue = event.target.value;
          }
          return result;
        });
      }
      return updatedField;
    });

    setSectionFields(tempSectionFields);
  };

  const deleteOptionsHandler = (fieldId, optionId) => {
    let tempSectionFields = [...sectionFields];

    tempSectionFields = tempSectionFields.map((field) => {
      let updatedField = field;
      if (updatedField.fieldId === fieldId) {
        const index = updatedField.options.findIndex((option) => option.optionId === optionId);
        updatedField.options.splice(index, 1);
      }
      return updatedField;
    });

    setSectionFields(tempSectionFields);
  };

  const changeFieldHandler = (event, fieldId, type) => {
    let tempSectionFields = [...sectionFields];

    const index = tempSectionFields.findIndex((field) => field.fieldId === fieldId);
    const currentField = tempSectionFields[index];
    let newFieldAdd;

    const newType = event.target.value;
    if (CategoryA.includes(type)) {
      if (CategoryA.includes(newType)) {
        newFieldAdd = {
          fieldId: currentField.fieldId,
          fieldLabel: currentField.fieldLabel,
          inputType: newType,
          fieldRequired: currentField.fieldRequired,
          fieldPlaceHolder: currentField.fieldPlaceHolder,
        };
      } else if (CategoryB.includes(newType)) {
        newFieldAdd = {
          fieldId: currentField.fieldId,
          fieldLabel: currentField.fieldLabel,
          inputType: newType,
          fieldRequired: currentField.fieldRequired,
          options: [{ optionId: v4(), optionValue: "" }],
        };
      } else {
        newFieldAdd = {
          fieldId: currentField.fieldId,
          fieldLabel: currentField.fieldLabel,
          inputType: newType,
          fieldRequired: currentField.fieldRequired,
          setReminder: false,
          fieldPlaceHolder: " ",
        };
      }
    } else if (CategoryB.includes(type)) {
      if (CategoryA.includes(newType)) {
        newFieldAdd = {
          fieldId: currentField.fieldId,
          fieldLabel: currentField.fieldLabel,
          inputType: newType,
          fieldRequired: currentField.fieldRequired,
          fieldPlaceHolder: " ",
        };
      } else if (CategoryB.includes(newType)) {
        const currentOptions = currentField.options;
        let newOptions = [];
        currentOptions.forEach((element) => {
          newOptions.push({ ...element, optionId: v4() });
        });
        newFieldAdd = {
          fieldId: currentField.fieldId,
          fieldLabel: currentField.fieldLabel,
          inputType: newType,
          fieldRequired: currentField.fieldRequired,
          options: newOptions,
        };
      } else {
        newFieldAdd = {
          fieldId: currentField.fieldId,
          fieldLabel: currentField.fieldLabel,
          inputType: newType,
          fieldRequired: currentField.fieldRequired,
          setReminder: false,
          fieldPlaceHolder: " ",
        };
      }
    } else {
      if (CategoryA.includes(newType)) {
        newFieldAdd = {
          fieldId: currentField.fieldId,
          fieldLabel: currentField.fieldLabel,
          inputType: newType,
          fieldRequired: currentField.fieldRequired,
          fieldPlaceHolder: " ",
        };
      } else {
        newFieldAdd = {
          fieldId: currentField.fieldId,
          fieldLabel: currentField.fieldLabel,
          inputType: newType,
          fieldRequired: currentField.fieldRequired,
          options: [{ optionId: v4(), optionValue: "" }],
        };
      }
    }

    tempSectionFields[index] = { ...newFieldAdd, mode: currentField.mode };

    setSectionFields(tempSectionFields);
  };

  const addFieldToSection = (field) => {
    setIsFieldActive(false);
    props.addFieldToSection(section.sectionId, field);
    setSectionFields(section.sectionFields);
  };

  const deleteFieldFromSection = (field) => {
    props.deleteFieldFromSection(section.sectionId, field, false);
  };

  const editFieldInSection = (field) => {
    setIsFieldActive(false);
    props.editFieldInSection(section.sectionId, field);
    setSectionFields(section.sectionFields);
  };

  return (
    <div
      className={`tab-section ${props.showInDocUpload ? "pt-6 mr-6" : "pt-6"}`}
    >
      <div className="section-title d-flex justify-content-between mt-4 mb-3">
        <div className="is-size-h6 bold">{section.sectionTitle}</div>
        {!props.viewOnly && props.showAddFieldButton && documentViewMode ? (
          <div className={isFieldAcive ? `action disabled` : `action`} onClick={handleAddField}>
            ＋ Add field
          </div>
        ) : null}
      </div>
      <div className={sectionFields.length > 0 ? "section-view" : " "}>
        {sectionFields.map((field, ind) => {
          if (field.mode === "Create" || field.mode === "Edit") {
            return (
              <TabField
                key={field.fieldId}
                field={field}
                index={ind}
                updatedField={updatedField}
                cancelFieldHandler={cancelFieldHandler}
                addOptionHandler={addOptionHandler}
                updateOptionValue={updateOptionValue}
                deleteOptionsHandler={deleteOptionsHandler}
                changeFieldHandler={changeFieldHandler}
                handleAddField={addFieldToSection}
                handleEditField={editFieldInSection}
                sectionTitle={section.sectionTitle}
              />
            );
          } else {
            let fieldType;
            switch (field.inputType) {
              case "TextField":
                fieldType = (
                  <TextFieldType
                    showInDocUpload={props.showInDocUpload}
                    viewOnly={props.viewOnly}
                    field={field}
                    fieldValueChangeHandler={props.fieldValueChangeHandler}
                  />
                );
                break;
              case "TextArea":
                fieldType = (
                  <TextAreaType
                    showInDocUpload={props.showInDocUpload}
                    viewOnly={props.viewOnly}
                    field={field}
                    fieldValueChangeHandler={props.fieldValueChangeHandler}
                  />
                );
                break;
              case "Radio":
                fieldType = (
                  <RadioType
                    showInDocUpload={props.showInDocUpload}
                    viewOnly={props.viewOnly}
                    field={field}
                    radioValueChangeHandler={props.radioValueChangeHandler}
                  />
                );
                break;
              case "Checkbox":
                fieldType = (
                  <CheckboxType
                    showInDocUpload={props.showInDocUpload}
                    viewOnly={props.viewOnly}
                    field={field}
                    checkboxValueChangeHandler={props.checkboxValueChangeHandler}
                  />
                );
                break;
              case "Dropdown":
                fieldType = (
                  <DropdownType
                    tabName={props.tabName}
                    showInDocUpload={props.showInDocUpload}
                    viewOnly={props.viewOnly}
                    field={field}
                    dropdownValueChangeHandler={props.dropdownValueChangeHandler}
                    sectionTitle={section.sectionTitle}
                  />
                );
                break;
                case "SearchDropdown":
                  fieldType = (
                    <SearchDropdownType
                      tabName={props.tabName}
                      showInDocUpload={props.showInDocUpload}
                      viewOnly={props.viewOnly}
                      field={field}
                      dropdownValueChangeHandler={props.dropdownValueChangeHandler}
                      sectionTitle={section.sectionTitle}
                      userRole={props.userRole}
                      handleAddNewTag={props.handleAddNewTag}
                    />
                  );
                  break;
              case "Date":
                fieldType = (
                  <DateType
                    showInDocUpload={props.showInDocUpload}
                    viewOnly={props.viewOnly}
                    field={field}
                    fieldValueChangeHandler={props.fieldValueChangeHandler}
                    description={sectionFields
                      .map((item) => {
                        if (item.fieldDateId === field.fieldId) {
                          return item.fieldValue;
                        }
                        return null;
                      })
                      .filter((dateType) => dateType !== null)}
                    index={ind}
                  />
                );
                break;
              case "DateDescription":
                fieldType = (
                  <DateDescriptionType
                    showInDocUpload={props.showInDocUpload}
                    viewOnly={props.viewOnly}
                    field={field}
                    fieldValueChangeHandler={props.fieldValueChangeHandler}
                    // dateDescription = {getDescription}
                  />
                );
                break;
              case "Number":
                fieldType = (
                  <NumberType
                    showInDocUpload={props.showInDocUpload}
                    viewOnly={props.viewOnly}
                    field={field}
                    fieldValueChangeHandler={props.fieldValueChangeHandler}
                  />
                );
                break;
              case "Currency":
                fieldType = (
                  <CurrencyType
                    showInDocUpload={props.showInDocUpload}
                    viewOnly={props.viewOnly}
                    field={field}
                    fieldValueChangeHandler={props.fieldValueChangeHandler}
                  />
                );
                break;
              default:
                fieldType = null;
            }
            if (fieldType === null) {
              return null;
            } else {
              return (
                <CustomField
                  key={field.fieldId}
                  viewOnly={props.viewOnly}
                  field={field}
                  handleEditField={handleEditField}
                  deleteFieldFromSection={deleteFieldFromSection}
                >
                  {fieldType}
                </CustomField>
              );
            }
          }
        })}
      </div>
    </div>
  );
};

export default TabSection;
